export class LabRequiredError extends Error {
  public constructor() {
    super('Please select a lab.');
  }
}
